import React, { Component } from 'react';
import PropTypes from "prop-types";
import { injectIntl } from 'react-intl';
import { messages } from  '../common/Translations';

class ButtonGroup extends Component {

    constructor(props) {
        super(props);
    }

    renderConfirmButton() {
        const { readyToConfirm, confirmText = 'Add', itemHasChildren, disableParentSelect } = this.props;

        if (!readyToConfirm) {
            return null;
        }

        if(itemHasChildren && disableParentSelect) {
            return null;
        }

        return (
            <input type="button"
                   className="btn btn-primary clickable"
                   value={confirmText}
                   onClick={this.props.onConfirm} />
        );
    }

    renderResetButton() {
        if (this.props.readyToConfirm) {
            return (
                <button className="btn btn-danger clickable ml-1"
                        role="button"
                        onClick={this.props.onReset}>
                    {this.props.intl.formatMessage(messages.multistepSelectButtonGroupResetButton)}
                </button>
            );
        }
    }

    render() {
        return (
            <div className="row pt-3">
                <div className="col line">
                    {this.renderConfirmButton()}
                    {this.renderResetButton()}
                </div>
            </div>
        )
    }
}

ButtonGroup.propTypes = {
    onReset: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    selectedItemName: PropTypes.string,
    itemHasChildren: PropTypes.bool,
    readyToConfirm: PropTypes.bool,
    confirmText: PropTypes.string,
    disableParentSelect: PropTypes.bool
};

export default injectIntl(ButtonGroup);


// WEBPACK FOOTER //
// ./web/src/components/multistep-select/ButtonGroup.jsx